import "./style.css";
import layout from "./layout.html";

export default class Contact {
  static selector = ".contact";

  constructor(block) {
    this.block = block;

    this.block.innerHTML = layout;
  }
}
